"use client";

import { useEffect } from "react";

import { STUDENT_CLUSTERS_LAYER_ID, STUDENTS_PLOTS_LAYER_ID } from "@/providers/maps/constants";
import { useLayer } from "@/providers/maps/hooks/use-layer";

import type maplibregl from "maplibre-gl";

export function usePlottingFiltersLayer(isApplied: boolean): void {
  const { setFilter: setPlotsFilter } = useLayer(STUDENTS_PLOTS_LAYER_ID);
  const { setFilter: setClustersFilter } = useLayer(STUDENT_CLUSTERS_LAYER_ID);

  useEffect(() => {
    const hideFilter: maplibregl.FilterSpecification = ["literal", false];
    const nextFilter = isApplied ? undefined : hideFilter;
    setPlotsFilter(nextFilter);
    setClustersFilter(nextFilter);
  }, [isApplied, setPlotsFilter, setClustersFilter]);
}
